import { render } from "./calendar.vue?vue&type=template&id=2f338864&ts=true"
import script from "./calendar.vue?vue&type=script&lang=ts"
export * from "./calendar.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__